import {
  Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef, ElementRef, Input,
  QueryList, ViewChildren
} from '@angular/core';
import { Router } from '@angular/router';
import { NegociosHeaderComponent } from '../../negocios/header';
import { PricePipe } from '@utils/pipes/price';
import { DialogsService } from '@services/dialogs-service';
import { NegociosService, PreciosService, ENTREGA_VALUES, NEGOCIO_TYPE_DISPO, NEGOCIO_TYPE_FORWARD, PosicionService, EntregaService, NEGOCIO_TYPE_PAGO_DIFERIDO } from '@services/index';

import { PATH_PRECIOS, PATH_NEW_PRECIO, PATH_VALIDATE_PRECIO } from '../../../navigation/navigation.module';
import { SignalrService } from '../../../signalr/signalR.service';
import { ColaboradorAutocompleteComponent } from '@common/autocomplete';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { parseDate, dateToUnixTime, DateTimePipe } from '@utils/index';
import { MonedaService } from '@services/moneda-service';
import { SpinnerService } from '@services/spinner-service';
import { ABMRolesService } from '@services/abm-roles-service';
import { ChipsSelectorComponent } from '@common/chips-selector/chips-selector.component';
import { PermisosService, PERM_ACCIONES_ID } from '@services/permisos-service';
import {PrecioGenericViewModel, PrecioViewModel} from '@utils/ViewModels';
import {PrecioMonitor, PrecioMonitorComponent} from '@common/index';

@Component({
  selector: 'app-precios',
  templateUrl: './precios.component.html',
  styleUrls: ['./precios.component.scss']
})
export class PreciosComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('dateFilterPicker') dateFilterPicker;
  @ViewChild('quickFilters') quickFilters: ElementRef;
  @ViewChild(ChipsSelectorComponent) filterMercado: ChipsSelectorComponent;
  @ViewChildren(ChipsSelectorComponent) chipFiltersList: QueryList<ChipsSelectorComponent>;

  monitorGenericoPrecios: PrecioMonitor[] = []

  @Input() parent: NegociosHeaderComponent;


  private viewMode = 'grid';

  private columns = [
    'fecha', 'negocio', 'entrega', 'moneda', 'soja', 'maiz', 'trigo', 'girasol', 'sorgo', 'mercado', 'responsable', 'validador'
  ];

  private productsOrder = ['Soja', 'Maiz', 'Trigo', 'Girasol', 'Sorgo'];

  // Columnas que usan un título no deducible desde su id en this.columns
  private needSpecialName = {};
  // Columnas cuyo título en modal de filtro difiere de su título en la tabla
  private needSpecialFilterName = {};
  // Columnas que necesitan filtro price
  private needPriceFilter = {soja: true, 'maiz': true, trigo: true, sorgo: true, girasol: true};
  // @ViewChild(ColaboradorAutocompleteComponent) colaboradorAutocompleteComponent;
  @ViewChildren(ColaboradorAutocompleteComponent) allColaboradorAutocompleteComponent: QueryList<ColaboradorAutocompleteComponent>;

  showQuickFilters = false;


  private filters = {};
  private chips = [];
  private quickFiltersModels = {
    list: {
      show: true,
      today: true,
      date: new Date()
    },
    grid: {
      today: true,
      date: new Date(),
      producto: null,
      moneda: null,
      entrega: null
    }
  };

  private entregaOptions = [];
  private productoOptions = [];
  private monedaOptions = [];
  private negocioOptions = [];

  private sortTimeout;

  private cotizacionDolar: any = {};
  private cotizacionLoaded = false;
  private cotizacionCollapse = false;


  // Columna de sorting elegida actualmente
  private sortColumn = 'fecha';
  private sortOrder = {};

  // Columnas con tipo de dato desde/hasta en números
  private fromToColumns = ['soja', 'maiz', 'trigo', 'girasol', 'sorgo'];
  // Columnas con tipo de dato autocompletar
  private arrayColumns = ['responsable', 'validador'];

  // Grid
  private products = [];
  private prices = [];

  private verticalScroll: any;
  private scrollSubscriber: any;
  private precioPage = 0;
  private loadingPrices: boolean;
  private allPricesLoaded: boolean;

  private signalRSubscriber: any;

  // Monitor
  preciosRaw: PrecioViewModel[] = [];

  monitorGroup = 'merc';
  monitorGroupOrder = true; // true = ascendente
  monitorAltGroupOrder = false; // toggle para ordenar productos alfabeticamente

  monitorOrder = 'publ';
  monitorOrderDirection = true; // true = ascendente


  meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];

  mercados: {ItemLabel: string, ID: number}[] = [];

  constructor(private router: Router,
              private detector: ChangeDetectorRef,
              private spinnerService: SpinnerService,
              private dialogsService: DialogsService,
              private negociosService: NegociosService,
              private monedaService: MonedaService,
              private posicionService: PosicionService,
              private entregaService: EntregaService,
              private preciosService: PreciosService,
              private rolesService: ABMRolesService,
              private pricePipe: PricePipe,
              private dateTimePipe: DateTimePipe,
              private signalRService: SignalrService) {
    monedaService.Options.subscribe(newValue => {
      this.monedaOptions = newValue;
    });
    rolesService.getProductos().subscribe(newValue => {
      this.productoOptions = newValue;
    });
    entregaService.PosicionOptions.subscribe(newValue => {
      this.entregaOptions = newValue;
    });
    preciosService.checkNewPricesForReview();
    preciosService.getMercadosPizarra().take(1).subscribe(x => {
      this.mercados = x.filter(y => y.Visibilidad).map(x => ({ID: x.Id, ItemLabel: x.Mercado}));
      this.setupMercadoFilter();
    });
  }

  ngOnInit() {
    // Select options
    this.negocioOptions = this.negociosService.getNegocioSelectOptions();

    this.columns.forEach(key => {
      this.sortOrder[key] = 0;
    });

  }

  viewEnter() {
    // posicion interval
    this.posicionService.loadOptions();
  }

  applyFilters() {
    if (this.viewMode === 'grid') {
      this.getMonitorPrecios();
    } else if (this.viewMode === 'list') {
      this.resetGrillaPrecios();
      this.buildChips();
      this.getGrillaPrecios();
    }
    this.showQuickFilters = false;
  }

  priceMeetsFilterRequirements(precio) {
    const fil = this.quickFiltersModels.grid;
    const colFilters: any = this.filters;

    if (!fil) {
      return true;
    }

    if (fil.moneda && precio.Moneda && precio.Moneda.Id && Number(fil.moneda) !== precio.Moneda.Id) {
      return false;
    }

    if (fil.producto && precio.Producto && precio.Producto.Id && Number(fil.producto) !== precio.Producto.Id) {
      return false;
    }

    if (fil.entrega && !precio.Posicion && precio.Entrega && precio.Entrega.Id !== fil.entrega.ID) {
      return false;
    }

    if (fil.entrega && precio.Posicion && precio.Posicion.Id !== fil.entrega.ID_POS) {
      return false;
    }

    this.allColaboradorAutocompleteComponent.forEach(colaboradorAutocompleteComponent => {
      if (colaboradorAutocompleteComponent.type === 'responsable') {
        const users = colaboradorAutocompleteComponent ? colaboradorAutocompleteComponent.selectedColaboradores.map(usu => usu.UserId) : [];
        if (users.length && precio.Usuario && users.indexOf(precio.Usuario.UserId) < 0) {
          return false;
        }
      } else if (colaboradorAutocompleteComponent.type === 'validador') {
        const users = colaboradorAutocompleteComponent ? colaboradorAutocompleteComponent.selectedColaboradores.map(usu => usu.UserId) : [];
        if (users.length && precio.Usuario && users.indexOf(precio.Usuario.UserId) < 0) {
          return false;
        }
      }
    });

    if (colFilters.filterProductos && precio.Producto && precio.Producto.Id &&
      (colFilters.filterProductos.findIndex(x => x === precio.Producto.Id) === -1)) {
      return false;
    }

    return true;
  }

  priceChange(self: PreciosComponent, precios): any {
    const productsChanged = [];
    if (precios && precios.length > 0) {
      const preciosArray = precios as PrecioViewModel[];
      preciosArray.forEach(precio => {
        // Verificar que el precio que llegó por signalR corresponda a los filtros aplicados, antes de procesarlo
        if (!self.priceMeetsFilterRequirements(precio)) {
          return;
        }
        // Si el precio esta presente, lo quitamos para que no haya duplicados
        this.preciosRaw = this.preciosRaw.filter(x => {
          const entregaRaw = x.Posicion !== null ? x.Posicion.Posicion : x.Entrega.Entrega;
          const entregaX = precio.Posicion !== null ? precio.Posicion.Posicion : precio.Entrega.Entrega;
          return !(x.Mercado.Codigo === precio.Mercado.Codigo &&
            x.Producto.Id === precio.Producto.Id &&
            x.Moneda.Id === precio.Moneda.Id &&
            entregaRaw.toUpperCase() === entregaX.toUpperCase());
        });
        this.preciosRaw.push(precio);
      });
      this.orderMonitor();
    }
    if (!self.detector['destroyed']) {
      self.detector.detectChanges();
    }
  }

  getColumnOrder(): any {
    const isProduct = this.productoOptions.find(x => x.Producto.toLowerCase() === this.sortColumn);
    if (isProduct) {
      return {
        ColumnName: 'producto',
        ProductoId: isProduct.Id
      };
    }
    return {
      ColumnName: this.sortColumn,
      ProductoId: 0
    };
  }

  getGrillaPrecios(): void {
    if (this.allPricesLoaded) { return; }
    this.spinnerService.setShowFlag(true);
    const quickFilters = this.quickFiltersModels.list;
    const gridFilters: any = this.filters;
    let negocioFilter = '';
    let idPosicion = 0;
    let idEntrega = 0;
    let idMoneda = 0;
    let idUsuarios: Array<number>;
    let idValidadores: Array<number>;
    const idMercado = this.filters['mercado'] ? this.filters['mercado'].model1 : 0;
    const productFilter: any = [];
    let productosFilterIds = [];
    if (gridFilters.negocio) {
      const negocio = gridFilters.negocio.model1;
      switch (negocio) {
        case 'FORWARD':
          negocioFilter = 'F';
          break;
        case 'DISPONIBLE':
          negocioFilter = 'D';
          break;
        case 'PAGO_DIFERIDO':
          negocioFilter = 'P';
          break;
        default:
          negocioFilter = 'B';
          break;
      }
    }
    if (gridFilters.entrega) {
      const posicionFilter = gridFilters.entrega.model1;
      idPosicion = posicionFilter.EsPosicion ? posicionFilter.ID_POS : 0;
      idEntrega = posicionFilter.EsPosicion ? 0 : posicionFilter.ID;
    }
    if (gridFilters.moneda) {
      idMoneda = gridFilters.moneda.model1;
    }
    if (gridFilters.responsable) {
      idUsuarios = gridFilters.responsable.map(x => {
        return x.UserId;
      });
    }
    if (gridFilters.validador) {
      idValidadores = gridFilters.validador.map(x => {
        return x.UserId;
      });
    }
    if (gridFilters.filterProductos) {
      productosFilterIds = gridFilters.filterProductos;
    }

    this.productoOptions.forEach(po => {
      if (gridFilters[po.Producto.toLowerCase()]) {
        const prodFilter = gridFilters[po.Producto.toLowerCase()];
        productFilter.push({
          ProductId: po.Id,
          DecimalRange: {
            MinValue: prodFilter.model1,
            MaxValue: prodFilter.model2
          }
        });
      }
    });

    // fecha de publicacion
    let fromDate = new Date();
    let toDate = new Date();

    let cotizacionFromDate = 0;
    let cotizacionToDate = 0;

    if (quickFilters.today) {
      fromDate = moment(fromDate).startOf('day').toDate();
      toDate = moment(toDate).endOf('day').toDate();
    } else {
      if (gridFilters.fecha) {
        fromDate = moment(gridFilters.fecha.startDate).startOf('day').toDate();
        toDate = moment(gridFilters.fecha.endDate).endOf('day').toDate();

      } else {
        fromDate = moment(quickFilters.date).startOf('day').toDate();
        toDate = moment(quickFilters.date).endOf('day').toDate();
      }

      if (gridFilters.cotizacion) {
        cotizacionFromDate = dateToUnixTime(moment(gridFilters.cotización.startDate).startOf('day').toDate());
        cotizacionToDate = dateToUnixTime(moment(gridFilters.cotización.endDate).endOf('day').toDate());
      }
    }
    const fromTime: number = dateToUnixTime(fromDate);
    const toTime: number = dateToUnixTime(toDate);

    this.loadingPrices = true;
    const columnOrder = this.getColumnOrder();

    this.preciosService.getGrillaPrecios(this.precioPage, columnOrder.ColumnName, this.sortOrder[this.sortColumn], columnOrder.ProductoId,
      fromTime, toTime, negocioFilter, idPosicion, idMoneda, idEntrega, idUsuarios, productFilter, idValidadores, productosFilterIds, idMercado)
      .subscribe((response: any) => {
        if (response.ResponseData) {
          const data = response.ResponseData.Item;
          data.forEach(r => {
            const price = {
              entrega: this.getEntregaText(r),
              negocio: this.getNegocioText(r),
              moneda: r.Moneda.Simbolo,
              fecha: this.dateTimePipe.transform(new Date(r.Fecha), 'dd/mm/yyyy hh:mm'),
              responsable: r.Responsable.UserFullName,
              validador: r.PrecioProducto[0] && r.PrecioProducto[0].Validador ? r.PrecioProducto[0].Validador.UserFullName : '-',
              mercado: r.Mercado ? r.Mercado.Mercado : '-'
            };
            r.PrecioProducto.map(p => {
              const propertyName = p.Producto.Producto.toString().toLowerCase();
              price[propertyName] = p.Precio.Precio;
            });
            this.prices.push(price);
          });
          this.allPricesLoaded = parseInt(response.ResponseData.Total, 10) === this.prices.length;
          this.precioPage++;
      }
      this.loadingPrices = false;
      this.spinnerService.setShowFlag(false);
    }, err => this.spinnerService.setShowFlag(false));
  }

  getNegocioText(precio) {

    if (precio.PosicionChicago) {
      return 'Basis';
    } else if (precio.Entrega.Entrega === ENTREGA_VALUES.N_POSICIONES) {
      return NEGOCIO_TYPE_FORWARD;
    } else if (precio.Entrega.Entrega === ENTREGA_VALUES.PAGO_DIFERIDO_PESOS) {
      return NEGOCIO_TYPE_PAGO_DIFERIDO;
    } else {
      return NEGOCIO_TYPE_DISPO;
    }
  }

  getEntregaText(precio) {

    if (precio.Entrega.Entrega === ENTREGA_VALUES.N_POSICIONES || precio.Entrega.Entrega === ENTREGA_VALUES.PAGO_DIFERIDO_PESOS) {
      return precio.Posicion.Posicion;
    } else {
      return precio.Entrega.Entrega;
    }
  }

  getMonitorPrecios(): void {
    this.spinnerService.setShowFlag(true);

    const filters = this.quickFiltersModels.grid;
    const esHoy = this.quickFiltersModels.grid.today;
    const fecha = filters.today ? moment().startOf('day').toDate() : moment(filters.date).startOf('day').toDate();
    const moneda = filters.moneda ? filters.moneda : null;
    const posicion = filters.entrega ? (filters.entrega.EsPosicion ? filters.entrega.ID_POS : null) : null;
    const entrega = filters.entrega ? (filters.entrega.EsPosicion ? null : filters.entrega.ID) : null;
    const producto = filters.producto ? filters.producto : null;
    const mercados = this.filterMercado.selectedIds;
    let users = [];
    let validadores = [];

    if (this.allColaboradorAutocompleteComponent) {
      this.allColaboradorAutocompleteComponent.forEach(colaboradorAutocompleteComponent => {
        if (colaboradorAutocompleteComponent && colaboradorAutocompleteComponent.type === 'responsable') {
          users = colaboradorAutocompleteComponent.selectedColaboradores.map(usu => usu.UserId);
        } else if (colaboradorAutocompleteComponent && colaboradorAutocompleteComponent.type === 'validador') {
          validadores = colaboradorAutocompleteComponent.selectedColaboradores.map(usu => usu.UserId);
        }
      });
    }

    this.preciosService.getMonitorPrecios(fecha, producto, moneda, posicion, entrega, users, validadores, esHoy, mercados).subscribe((response: any) => {
      if (response.ResponseData) {
        const productsResponse = response.ResponseData;
        if (productsResponse && productsResponse.length > 0) {
          this.preciosRaw = [];
          response.ResponseData.forEach(group => {
            group.Precios.forEach(precio => {
              this.preciosRaw.push({...precio, Producto: group.Producto} as PrecioViewModel);
            });
          })
          this.orderMonitor();
        } else {
          this.products = [];
          this.preciosRaw = [];
          this.orderMonitor();
        }
      }
      this.spinnerService.setShowFlag(false);
    }, err => this.spinnerService.setShowFlag(false));
  }

  ngAfterViewInit() {

    // CUSTOM VERTICAL SCROLL CON STICKY HEADER
    this.verticalScroll = window.document.querySelector('.mat-drawer-content');

    // INFINITE SCROLL
    this.scrollSubscriber = Observable.fromEvent(this.verticalScroll, 'scroll')
      .debounceTime(300)
      .map(() => this.verticalScroll.scrollTop)
      .subscribe(x => {
        const url = location.href.substr(location.href.lastIndexOf('/') + 1);
        if (url !== PATH_PRECIOS || this.viewMode !== 'list' || this.loadingPrices || this.allPricesLoaded) { return; }
        const max = this.verticalScroll.scrollHeight - this.verticalScroll.clientHeight;
        if (x > max * 0.7) {
          this.getGrillaPrecios();
        }
      });

    this.getMonitorPrecios();
    // this.getGrillaPrecios();

    this.signalRSubscriber = this.signalRService.newPrice.subscribe(x => {
      this.priceChange(this, x);
      this.preciosService.checkNewPricesForReview();
    });


    this.viewEnter();

  }

  viewPriceDetail(price, producto) {
    this.dialogsService.showPrecioDetailDialog(price.user, price.date, price.validador, false, price.publicacionDate, producto);
  }

  changeViewMode(e, mode) {
    e.stopPropagation();

    this.viewMode = mode;

    // Al cambiar a la grilla por primera vez en la sesión cargar el listado
    if (this.viewMode === 'list' && !this.allPricesLoaded && !this.prices.length) {
      this.getGrillaPrecios();
    }
  }

  openFilterModal(column) {
    clearTimeout(this.sortTimeout);
    this.dialogsService.showPreciosFilterDialog(column, this.getColumnTitleForFilter(column), this.filters)
      .subscribe((res: any) => {
        if (res) {
          this.filters = res.filters;

          // Si elegimos Guardar pero no cargamos ninguna info en este filtro, lo quitamos
          if (this.fromToColumns.indexOf(column) >= 0) {
            if (typeof this.filters[column].model1 !== 'number' && typeof this.filters[column].model2 !== 'number') {
              delete this.filters[column];
            }
          } else if (this.arrayColumns.indexOf(column) >= 0) {
            if (!this.filters[column] || this.filters[column].length === 0) {
              delete this.filters[column];
            }
          }
        }

        if (this.filters['fecha']) {
          this.quickFiltersModels.list.today = false;
          this.quickFiltersModels.list.show = false;
        }

        this.buildChips();

        this.resetGrillaPrecios();
        this.getGrillaPrecios();
      });
  }

  buildChips() {
    this.chips = Object.keys(this.filters).map(key => {
      let value = '';
      switch (key) {
        case 'fecha':
        case 'cotización':
          value = moment(this.filters[key].startDate).format('DD-MM-YY') + ' al ' + moment(this.filters[key].endDate).format('DD-MM-YY');
          break;
        case 'negocio':
        case 'entrega':
        case 'moneda':
        case 'mercado':
          value = this.filters[key].model1Value;
          break;
        case 'responsable':
          if (this.filters['responsable'].length === 1) {
            value = this.filters['responsable'][0].UserFullName;
          } else {
            value = 'Varios';
          }
          break;
        case 'validador':
          if (this.filters['validador'].length === 1) {
            value = this.filters['validador'][0].UserFullName;
          } else {
            value = 'Varios';
          }
          break;
        case 'soja':
        case 'maiz':
        case 'trigo':
        case 'sorgo':
        case 'girasol':
          value = this.filters[key].model1 + '-' + this.filters[key].model2;
          break;
        case 'filterProductos':
          if (this.filters['filterProductos'].length === 1) {
            value = this.productoOptions[this.productoOptions.findIndex(x => x.Id === this.filters['filterProductos'][0])].Producto;
          } else {
            value = 'Varios';
          }

      }

      return {
        col: key,
        title: this.getChipsTitle(key),
        value
      };
    });
  }

  getChipsTitle(key) {
    if (key === 'filterProductos') {
      return 'Producto';
    } else {
      return key.charAt(0).toUpperCase() + key.slice(1);
    }
  }

  resetGrillaPrecios() {
    this.precioPage = 0;
    this.allPricesLoaded = false;
    this.prices = [];
  }

  sortByColumn(column, immediate) {
    clearTimeout(this.sortTimeout);
    this.sortTimeout = setTimeout(() => {
      if (this.sortColumn === column) {
        this.sortOrder[column] = (this.sortOrder[column] + 1) % 2;
      } else {
        this.columns.forEach(element => {
          this.sortOrder[element] = 0;
        });
        this.sortOrder[column] = (this.sortOrder[column] || 0);
      }
      this.sortColumn = column;
      this.resetGrillaPrecios();
      this.getGrillaPrecios();
    }, immediate ? 0 : 250);
  }

  getColumnTitle(col) {
    return col.charAt(0).toUpperCase() + col.slice(1);
  }

  getColumnTitleForFilter(col) {
    return this.needSpecialFilterName[col] || this.getColumnTitle(col);
  }

  removeFilter(chip) {
    this.chips = this.chips.filter(c => c.col !== chip.col);

    if (chip.col === 'fecha') {
      this.quickFiltersModels.list.today = true;
      this.quickFiltersModels.list.show = true;
    }

    if (chip.col === 'filterProductos') {
      this.chipFiltersList.forEach(fil => {
        if (fil.Type === 'producto') {
          fil.unselectAllOptions();
        }
      });
    }

    delete this.filters[chip.col];

    if (this.viewMode === 'list') {
      this.resetGrillaPrecios();
      this.getGrillaPrecios();
    }
  }

  showDateFilterPicker() {
    this.dateFilterPicker.open();
  }

  onCreateNewPrecio(index?) {
    if (index) {
      this.router.navigate([PATH_NEW_PRECIO, index]);
    } else {
      this.router.navigate([PATH_NEW_PRECIO]);
    }
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
    if (this.signalRSubscriber) {
      this.signalRSubscriber.unsubscribe();
    }
  }

  getCotizacionDolar() {
    this.preciosService.getCotizacionDolar()
      .subscribe(x => {
        if (x) {
          this.cotizacionDolar = x;
          this.cotizacionDolar.Fecha = this.dateTimePipe.transform(parseDate(x.Fecha), 'dd/mm/yyyy hh:mm');
          this.cotizacionLoaded = true;
        }
      });
  }

  resetFilters() {
    if (this.viewMode === 'list') {
      this.quickFiltersModels.list = {
          show: true,
          today: true,
          date: new Date()
        };
    } else {
      this.quickFiltersModels.grid = {
        today: true,
        date: new Date(),
        producto: null,
        moneda: null,
        entrega: null
      };
    }
    this.filters = {};
    this.chips = [];
    this.sortColumn = 'fecha';
    this.showQuickFilters = false;
    this.filterMercado.unselectAllOptions();
    this.applyFilters();
  }

  filterProductChanged(values) {
    if (values.SelectedIds.length) {
      this.filters['filterProductos'] = values.SelectedIds;
    } else {
      delete this.filters['filterProductos'];
    }
  }

  orderMonitor(resetAlt = false): void {
    if (resetAlt) {
      this.monitorAltGroupOrder = false;
    }

    if (this.preciosRaw.length) {
      const precios = this.preciosRaw.map(x => {
        return {
          Fecha: moment(x.Fecha).format('HH:mm') + ' hs.',
          Grupo: this.monitorGroup === 'merc' ? x.Mercado.Mercado : x.Producto.Producto,
          Superior: this.monitorGroup === 'merc' ? x.Producto.Producto : x.Mercado.Mercado,
          Inferior: x.Posicion !== null ? x.Posicion.Posicion : x.Entrega.Entrega,
          Moneda: x.Moneda.Simbolo,
          Precio: this.pricePipe.transform(x.Precio, 'fill'),
          Varianza: x.Varianza,
          PrecioRAW: this.parsePrecioGenericPrecio(x),
          SaltoLinea: false,
          FechaRaw: moment(x.Fecha).unix(),
        } as PrecioMonitor;
      });

      precios.sort((a, b) => {
        /* damos inicio a la parafernalia que sera esta sortFunction...
        no existe una division en secciones si no que los grupos y precios-seccion se dibujan segun la posicion
        en la que se encuentran dentro del array... por lo que el sort completo se define aqui y ahora...*/

        // NOTA AL POBRE QUE TENGA QUE MODIFICAR ESTO
        // el ordenamiento aqui y en pizarra difieren, aqui los saltos de linea hacen que sea imposible ordenar por
        // el subgrupo, por lo que quitamos producto y mercado de la lista de ordenamientos. Pero pizarra al no tener salto
        // de linea, no necesita esto, por lo que aun se puede ordenar por esos valores

        // Paso 1: Ordenar los Grupos
        if (a.Grupo !== b.Grupo) {
          if (this.monitorGroup === 'prod') {
            return this.monitorAltGroupOrder ?
              // alternativo, alfabeticamente
              compare(a.Grupo, b.Grupo, this.monitorGroupOrder) :
              // normal, por score de producto
              compare(getProductoScore(a.Grupo), getProductoScore(b.Grupo), this.monitorGroupOrder)
          } else {
            return compare(a.Grupo, b.Grupo, this.monitorGroupOrder)
          }
        }

        // Paso 2: Ordenar en cada grupo el subgrupo, ya sea producto o mercado.
        // Por cada producto o mercado se debe producir un salto de linea. Dicho salto se define más abajo.

        // tenemos en cuenta el grupo, si es producto, ordenamos por mercado internamente y viceversa para producto
        // esto es asi dado que ahora producto y mercado, internamente son un subgrupo, por lo que se quitan de la lista de
        // opciones de ordenamiento

        if (a.Superior !== b.Superior) {
          if (this.monitorGroup === 'prod') {
            // comparamos segun el orden superior
            return compare(a.Superior, b.Superior, true);
          }

          if (this.monitorGroup === 'merc') {
            // comparamos segun el score del producto
            return compare(getProductoScore(a.Superior), getProductoScore(b.Superior), true);
          }
        }

        // Paso 3: Orden interno de los subgrupos (mercado o producto)
        switch (this.monitorOrder) {
          case 'mon':
            // comparamos segun la moneda y si son iguales, por fecha
            return a.Moneda === b.Moneda ? compare(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection)
              : compare(a.Moneda, b.Moneda, this.monitorOrderDirection);
          case 'publ':
            return compare(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection);
          case 'pos':
            const aVal = a.Inferior.toUpperCase();
            const bVal = b.Inferior.toUpperCase();
            // primero verificamos si estamos ante entidades iguales
            if (getScore(aVal) === getScore(bVal)) {
              // estamos ante entidades iguales, realizamos las comparaciones internas
              // FORWARD
              if (getScore(aVal) === 10) {
                // si son iguales, ordenar por fecha de publicacion
                // negamos el orden dado que ENTREGADO tiene prioridad, pero es LGBT y larga con E, pero la A viene antes...
                return aVal === bVal ? compare(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection) :
                  compare(aVal, bVal, !this.monitorOrderDirection);
                // POSICION
              } else if (getScore(aVal) === 5) {
                const namesA = aVal.split('-');
                const namesB = bVal.split('-');

                if (namesA.length + namesB.length === 2) {
                  return this.monitorOrderDirection ? this.meses.indexOf(namesA[0]) - this.meses.indexOf(namesB[0]) : this.meses.indexOf(namesB[0]) - this.meses.indexOf(namesA[0]);
                } else if (namesA.length !== namesB.length) {
                  return this.monitorOrderDirection ? namesA.length - namesB.length : namesB.length - namesA.length;
                } else {
                  if (namesA[1] === namesB[1]) {
                    return this.monitorOrderDirection ? this.meses.indexOf(namesA[0]) - this.meses.indexOf(namesB[0]) : this.meses.indexOf(namesB[0]) - this.meses.indexOf(namesA[0]);
                  } else {
                    return this.monitorOrderDirection ? Number(namesA[1]) - Number(namesB[1]) : Number(namesB[1]) - Number(namesA[1]);
                  }
                }
                // DIFERIDO
              } else if (getScore(aVal) === 3) {
                return aVal === bVal ? compare(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection) :
                  compare(moment(aVal, 'DD/MM/YYYY').unix(), moment(bVal, 'DD/MM/YYYY').unix(), this.monitorOrderDirection);
              }
            } else {
              // en caso de ser entidades distintas, las ordenamos segun puntaje de orden
              return compare(getScore(aVal), getScore(bVal), !this.monitorOrderDirection);
            }
        }
        return 0;
      })

      // ahora aplicamos el salto de linea
      precios.forEach((precio, i) => {
        // recordemos que los arrays se arrancan en 0 por lo que para sumar 1, debemos sumar 2 al compara el length
        if ((i + 2) <= precios.length) {
          // si el siguiente valor superior, es distinto al valor actual, en el actual preparamos el salto de linea
          if (precio.Superior !== precios[i+1].Superior) {
            precio.SaltoLinea = true;
          }
        }
      })

      this.monitorGenericoPrecios = [];
      this.monitorGenericoPrecios = precios.slice();
    } else {
      this.monitorGenericoPrecios = [];
    }
  }

  parsePrecioGenericPrecio(precio: PrecioViewModel): PrecioGenericViewModel {
    return {
      Actual: precio.Actual,
      Entrega: precio.Entrega,
      FechaCreacion: moment(precio.Fecha).unix(),
      FechaPublicacion: 0,
      Id: precio.Id,
      Mercado: precio.Mercado,
      Moneda: precio.Moneda,
      Posicion: precio.Posicion,
      Precio: precio.Precio,
      Producto: precio.Producto,
      Usuario: precio.Usuario,
      Validador: precio.Validador,
      Varianza: precio.Varianza
    }
  }

  setupMercadoFilter() {
    if (this.filterMercado) {
      this.filterMercado.optionsChange(this.mercados);
    }
  }

  monitorGroupOrderChange(): void {
    // revisamos si el grupo es productos, de ser asi, pasamos al modo alternativo
    // donde ordenamos los productos alfabeticamente y no por score

    // si estamos ordenando el grupo y estamos en productos siempre estaremos en el modo alternativo,
    // de lo contrario lo desactivamos
    this.monitorAltGroupOrder = this.monitorGroup === 'prod';

    this.monitorGroupOrder = !this.monitorGroupOrder;
    this.orderMonitor();
  }

  setupChipFilters(id: string) {
    this.chipFiltersList.forEach(filter => {
      if (filter.Type === id) {

        if (id === 'mercado') {
          this.filterMercado.optionsChange(this.mercados);
        }

        if (id === 'producto') {
          filter.optionsChange(this.productoOptions.map(x => {
            return {ID: x.Id, ItemLabel: x.Producto};
          }));
        }
      }
    })
  }

}
export function compare(a, b, direcion: boolean): number {
  if (a < b) { return direcion ? -1 : 1; }
  if (a > b) { return direcion ? 1 : -1; }
  return 0;
}

function getScore(val: string): number {
  let score = 0;
  if (val === 'ENTREGADO' || val === 'A ENTREGAR') {score = 10;}
  if (val.includes('-')) {score = 5;}
  if (val.includes('/')) {score = 3;}
  return score;
}

export function getProductoScore(val: string): number {
  const producto = val.toLowerCase();
  const values = ['sorgo', 'girasol', 'trigo', 'maiz', 'maíz', 'soja'];
  // en caso de ser un producto nuevo, el resultado será -1 por lo que estara debajo de todos en la lista
  return values.indexOf(val);
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios/precios.component.ts